var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M13.4408 35.546H34.875C37.3237 35.546 39.3158 33.5538 39.3158 31.1052V16.8946C39.3158 14.446 37.3237 12.4539 34.875 12.4539H13.4408C10.9921 12.4539 9 14.446 9 16.8946V31.1052C9 33.5538 10.9921 35.546 13.4408 35.546ZM10.7763 16.8946C10.7763 15.4255 11.9716 14.2302 13.4408 14.2302H34.875C36.3442 14.2302 37.5395 15.4255 37.5395 16.8946V31.1052C37.5395 32.5743 36.3442 33.7696 34.875 33.7696H13.4408C11.9716 33.7696 10.7763 32.5743 10.7763 31.1052V16.8946Z","fill":"white","key":0}),React.createElement("path",{"d":"M19.7168 18.0498V30.1227L30.4043 23.9873L19.7168 18.0498ZM21.4931 21.0686L26.7925 24.0127L21.4931 27.0549V21.0686Z","fill":"white","key":1})]);
}

Youtube.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = Youtube;

Youtube.default = Youtube;
